import { Badge, BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import InfoIcon from '@material-ui/icons/Info';
import { useTranslation } from 'react-i18next';

export type MobileMenuTabsProps = {
    a11yProps: (index: string) => object;
    displayQuotation: boolean;
    submittedQuoteCount: number;
    value: string;
    setValue: (value: string) => void;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        bottomNavigation: {
            backgroundColor: '#000',
            position: 'fixed',
            bottom: 0,
            width: '100%',
            height: theme.spacing(10),
            // stated explicitly so the bar sits on the same layer as the fixed top app bar, above
            // the Autocomplete popup, which keeps an open dropdown clipped behind both bars
            zIndex: theme.zIndex.appBar,
        },
        BottomNavigationAction: {
            color: '#717073',
            alignItems: 'flex-start',
            paddingTop: theme.spacing(1.5),
            '&.Mui-selected': {
                paddingTop: theme.spacing(1.5),
            },
        },
        bottomNavigationSelected: {
            color: theme.palette.secondary.main,
            '& svg': {
                fill: theme.palette.secondary.main,
            },
        },
        badgePosition: {
            top: 6,
            left: 20,
            transform: 'scale(1) translate(50%, -50%)',
        },
    })
);

const MobileMenuTabs = ({ value, setValue, a11yProps, displayQuotation, submittedQuoteCount }: MobileMenuTabsProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage']);
    const styles = useStyles();

    return (
        <BottomNavigation
            className={styles.bottomNavigation}
            onChange={(event, value) => setValue(value)}
            value={value}
        >
            <BottomNavigationAction
                className={styles.BottomNavigationAction}
                classes={{ selected: styles.bottomNavigationSelected }}
                icon={<InfoIcon />}
                label={t('purchaseTransactionsPage:menu.transaction')}
                value="transaction"
                showLabel
                {...a11yProps('transaction')}
            />
            <BottomNavigationAction
                className={styles.BottomNavigationAction}
                classes={{ selected: styles.bottomNavigationSelected }}
                icon={<DriveEtaIcon />}
                label={t('purchaseTransactionsPage:menu.vehicle')}
                value="vehicle"
                showLabel
                {...a11yProps('vehicle')}
            />
            <BottomNavigationAction
                className={styles.BottomNavigationAction}
                classes={{ selected: styles.bottomNavigationSelected }}
                icon={<DriveEtaIcon />}
                label={t('purchaseTransactionsPage:menu.valuation')}
                value="valuation"
                showLabel
                {...a11yProps('valuation')}
            />
            {displayQuotation && (
                <BottomNavigationAction
                    className={styles.BottomNavigationAction}
                    classes={{ selected: styles.bottomNavigationSelected }}
                    icon={
                        <Badge
                            badgeContent={submittedQuoteCount}
                            classes={{ anchorOriginTopRightRectangle: styles.badgePosition }}
                            color="secondary"
                            showZero={false}
                        >
                            <AttachMoneyIcon />
                        </Badge>
                    }
                    label={t('purchaseTransactionsPage:menu.quotation')}
                    value="quotation"
                    showLabel
                    {...a11yProps('quotation')}
                />
            )}
            <BottomNavigationAction
                className={styles.BottomNavigationAction}
                classes={{ selected: styles.bottomNavigationSelected }}
                icon={<AssignmentIndIcon />}
                label={t('purchaseTransactionsPage:menu.handover')}
                value="handover"
                showLabel
                {...a11yProps('handover')}
            />
        </BottomNavigation>
    );
};

export default MobileMenuTabs;
